// https://vuex.vuejs.org/en/getters.html
import _ from 'lodash'
// authorized lets you know if the token is true or not
export default {
  authorized: state => !!state.token,
  authstatus: state => state.authStatus,
  hasPermission: (state) => (id) => {
    // if (state.user.permissions && state.user.permissions.length != 0) {
    //   console.debug('state data exists')
    // } else {
/** handle open new tab (this is not best practices as can lead to "infinite update loop in component render function" **/
    //   console.debug('handle open new tab')
    //   const claims = jwtDecode(state.token)
    //   if (claims) {
    //     state.user = claims
    //   } else {
    //     state.user.permissions = []
    //   }
    // }
    if (state.permissions && state.permissions.length != 0) {
      console.debug('permissions state exists')
      if (Array.isArray(id)) {
        if (_.intersection(state.permissions, id).length > 0) {
            return true
        }
        return false
      } else {
        return state.permissions.includes(id)
      }
    } else {
      return false
    }
  },
  getNotifications: state => state.notification
}
